//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CacheModule } from "@/utils/commonUtils";
import { mutations } from "@/observable/store";
export default {
  name: "logout",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Boolean,
    },
  },
  methods: {
    abandonHandler() {
      this.$emit("change", false);
    },
    logoutHandler() {
      mutations.getUid("0");
      mutations.getsyToken("");
      CacheModule.remove("userInfo");
      this.$router.replace("/personal");
    },
  },
};
